'use client';
import { browserAction } from './browserAction.js';

/**
 * SSR-safe alias для window.requestAnimationFrame.
 * */ const requestAnimationFrame = browserAction((...args)=>window.requestAnimationFrame(...args));
/**
 * SSR-safe alias для window.cancelAnimationFrame.
 * */ const cancelAnimationFrame = browserAction((...args)=>window.cancelAnimationFrame(...args));

export { cancelAnimationFrame, requestAnimationFrame };
//# sourceMappingURL=requestAnimationFrame.js.map
